import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { Toaster } from 'react-hot-toast'
import App from './App.jsx'
import { AuthProvider } from './contexts/AuthContext.jsx'
import './index.css'

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <BrowserRouter
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true
      }}
    >
      <AuthProvider>
        <App />
        <Toaster
          position="bottom-right"
          containerStyle={{ bottom: 24, left: 40 }}
          toastOptions={{
            duration: 4000,
            success: {
              style: {
                background: '#f0fdf4',
                color: '#166534',
                border: '1px solid #bbf7d0',
                borderRadius: '16px',
                padding: '12px 16px',
                fontSize: '14px',
                fontWeight: '500',
                boxShadow: '0 4px 24px rgba(15,23,42,0.10)'
              },
              iconTheme: { primary: '#16a34a', secondary: '#f0fdf4' }
            },
            error: {
              style: {
                background: '#fef2f2',
                color: '#991b1b',
                border: '1px solid #fecaca',
                borderRadius: '16px',
                padding: '12px 16px',
                fontSize: '14px',
                fontWeight: '500',
                boxShadow: '0 4px 24px rgba(15,23,42,0.10)'
              },
              iconTheme: { primary: '#dc2626', secondary: '#fef2f2' }
            },
            style: {
              background: '#f8fafc',
              color: '#1e293b',
              border: '1px solid #e2e8f0',
              borderRadius: '16px',
              padding: '12px 16px',
              fontSize: '14px',
              fontWeight: '500',
              boxShadow: '0 4px 24px rgba(15,23,42,0.10)'
            }
          }}
        />
      </AuthProvider>
    </BrowserRouter>
  </StrictMode>,
)
